import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import CryptoJS from 'crypto-js';

const WithAuth = (WrappedComponent) => {
  const AuthenticatedComponent = () => {
    const udiseNumber = localStorage.getItem('udiseNumber');
    const hu = localStorage.getItem('hu');
    const hashedUdiseNumber = CryptoJS.SHA256(udiseNumber).toString();

    const language = localStorage.getItem('language');
    const location = useLocation();

    if (udiseNumber && language && String(hu) == hashedUdiseNumber) {
      return <WrappedComponent />;
    } else {
      return <Navigate to="/" state={{ from: location }} replace />;
    }
  };

  return AuthenticatedComponent;
};

export default WithAuth;